import { toolActivityBasename } from "../tool-activity-basename";
/** Capture target for live labels: `localhost:3000`, a file basename, a path. */
export function captureTarget(url: string | undefined): string | undefined {
  if (!url) {
    return undefined;
  }
  try {
    const parsed = new URL(url);
    if (parsed.protocol === "file:") {
      return toolActivityBasename(parsed.pathname) ?? url;
    }
    return parsed.host || parsed.hostname;
  } catch {
    return toolActivityBasename(url) ?? url;
  }
}
